import type { IValidator } from './IValidator';

export class EmailValidator implements IValidator {
    status: string = '';
    statusType: 'info' | 'warning' | 'error' | 'na' = 'error';
    value?: string;
    required: boolean = false;
    public constructor(isRequired?: boolean) {
        this.required = isRequired || false;
    }
    Status(): string {
        return this.status;
    }

    StatusType(): 'info' | 'warning' | 'error' | 'na' {
        return this.statusType;
    }

    Value(): string {
        return this.value as string;
    }

    Validate(cellvalue: string): boolean {
        if (cellvalue.trim() === '' && !this.required) {
            return true;
        }

        // use regexp to check if it is a valid email
        const emailRegexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegexp.test(cellvalue)) {
            this.status = 'emailvalidator.invalidemail';
            this.statusType = this.required ? 'error' : 'warning';
            return false;
        }

        return true;
    }
}
